import { render, staticRenderFns } from "./VaPagination.vue?vue&type=template&id=d50812c6&"
import script from "./VaPagination.vue?vue&type=script&lang=js&"
export * from "./VaPagination.vue?vue&type=script&lang=js&"
import style0 from "./VaPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports